import Cookies from 'js-cookie'
import type { ProfileType } from '@/types/profile-type'

const session: string | null = Cookies.get('session-storage') ?? null

export const sessionCookie: {
  state: {
    status: 'authenticated' | 'unauthenticated' | 'loading'
    profile: ProfileType
  }
} | null = session ? JSON.parse(session) : null
